import { jsPDF } from 'jspdf';

export function addIdImovelBox(
  doc: jsPDF,
  x: number,
  y: number,
  w: number,
  title: string,
  content: string
) {
  doc.setDrawColor('#ababab');
  doc.setLineWidth(0.04);
  doc.rect(x, y, w, 0.9);

  doc.line(x, y + 0.35, x + w, y + 0.35);
  doc.setFont('Roboto', 'bold');

  doc.setFontSize(7);
  doc.text(title, x + 0.1, y + 0.25);

  doc.setFont('Roboto', 'regular');
  doc.setFontSize(8);
  doc.text(content, x + 0.1, y + 0.71);
}

export function addBorderlessTableCol(
  doc: jsPDF,
  x: number,
  y: number,
  width: number,
  pos: 'center' | 'left',
  title: string,
  content: string
) {
  doc.setFont('Roboto', 'bold');
  doc.setFontSize(9);

  const titleWidth = doc.getTextWidth(title);
  const titleX = pos === 'center' ? x + width / 2 : x;
  const titleSplitText = doc.splitTextToSize(title, width) as string[];

  doc.text(titleSplitText, titleX, y, { align: pos });

  doc.setFont('Roboto', 'regular');
  doc.setFontSize(8);

  const contentSplitText = doc.splitTextToSize(content, width) as string[];
  const largestContentSplitTextItem = contentSplitText.reduce(
    (a, b) => (a.length > b.length ? a : b),
    ''
  );
  const largestSplitTextItemWidth = doc.getTextWidth(
    largestContentSplitTextItem
  );
  const contentX = pos === 'center' ? x + width / 2 : x;

  doc.text(
    contentSplitText,
    contentX,
    y + (0.5 + (titleSplitText.length - 1) * 0.4),
    { align: pos }
  );
}

export function addBorderedTableCol(
  doc: jsPDF,
  x: number,
  y: number,
  width: number,
  title: string,
  subCols: {
    title: string;
    width: number;
    content: string;
  }[] = [],
  content?: string
) {
  doc.setDrawColor('#ababab');
  doc.setLineWidth(0.04);

  doc.rect(x, y, width, 2.5);

  doc.setFont('Roboto', 'regular');
  doc.setFontSize(6);

  const titleSplitText = doc.splitTextToSize(title, width - 0.2) as string[];

  doc.text(
    titleSplitText,
    x + width / 2,
    titleSplitText.length > 1 ? y + 0.3 : y + 0.44,
    { align: 'center' }
  );

  doc.line(x, y + 0.7, x + width, y + 0.7);

  let accX = x;

  doc.line(x, y + 1.3, x + width, y + 1.3);

  if (subCols.length > 0) {
    subCols.forEach(({ title, width, content }) => {
      doc.setFontSize(6);
      doc.text(title, accX + width / 2, y + 1.1, { align: 'center' });

      doc.line(accX + width, y + 0.7, accX + width, y + 2.5);

      doc.setFontSize(7);
      doc.text(content, accX + width / 2, y + 2, { align: 'center' });

      accX += width;
    });
  } else {
    doc.setFontSize(7);
    const contentSplit = doc.splitTextToSize(content as string, width - 0.1);

    doc.text(
      contentSplit,
      accX + width / 2,
      contentSplit.length > 1 ? y + 1.8 : y + 2,
      { align: 'center' }
    );
  }
}

export function addSignatureSections(
  doc: jsPDF,
  x: number,
  y: number,
  totalWidth: number,
  sections: {
    entity: string;
  }[]
) {
  doc.setDrawColor('#ababab');
  doc.setLineWidth(0.04);

  doc.rect(x, y, totalWidth, 2.6);

  const sectionWidth = totalWidth / sections.length;

  doc.setFont('Roboto', 'regular');
  sections.forEach(({ entity }, i) => {
    if (i !== 0) {
      doc.line(x + sectionWidth * i, y, x + sectionWidth * i, y + 2.6);
    }

    doc.setFontSize(7);
    doc.text(
      '(    ) VIÁVEL         (    ) NÃO VIÁVEL',
      x + sectionWidth * i + sectionWidth / 2,
      y + 0.4,
      { align: 'center' }
    );

    doc.setFontSize(8);
    doc.text(entity, x + sectionWidth * i + sectionWidth / 2, y + 2.1, {
      align: 'center',
    });
  });
}

export function addMapLegendItem(
  doc: jsPDF,
  x: number,
  y: number,
  label: string,
  size: 'small' | 'normal' = 'normal',
  fillColor?: string,
  borderColor?: string
) {
  if (fillColor) {
    doc.setFillColor(fillColor);
  }

  if (borderColor) {
    doc.setDrawColor(borderColor);
  }

  let rectStyle: string;

  if (fillColor && borderColor) {
    rectStyle = 'FD';
  } else if (fillColor) {
    rectStyle = 'F';
  } else {
    rectStyle = 'S';
  }

  let height = 0.32;
  let newY = y;

  if (borderColor) {
    newY += 0.04;
    height -= 0.08;
  }

  doc.setLineWidth(0.04);
  doc.rect(
    borderColor ? x + 0.04 : x,
    size === 'small' ? newY + 0.1 : newY,
    borderColor ? 0.72 : 0.8,
    size === 'small' ? height - 0.2 : height,
    rectStyle
  );

  doc.setFontSize(6);
  doc.text(label, x + 1, y + 0.25);
}

export function rgbaToHex(value: string) {
  const rx = /rgba?\(([0-9]{1,3}),\s?([0-9]{1,3}),\s?([0-9]{1,3})/;
  const match = rx.exec(value);

  if (match) {
    const red = Number.parseInt(match[1]).toString(16).padStart(2, '0');
    const green = Number.parseInt(match[2]).toString(16).padStart(2, '0');
    const blue = Number.parseInt(match[3]).toString(16).padStart(2, '0');

    return `#${red}${green}${blue}`;
  }

  return '';
}
